export default {"src":"/_next/static/media/graphic4.fc399b17.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};